module.exports = __webpack_public_path__ + "img/arvores.156d1c98.jpg";